import React from 'react';
import { Container, Typography, Box, Card, CardContent, Button, Alert } from '@mui/material';
import { Delete, Email, Security } from '@mui/icons-material';

const DataDeletion = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Data Deletion Instructions
        </Typography>
        <Typography variant="h6" color="text.secondary">
          How to delete your data from HypeCircle
        </Typography>
      </Box>

      <Alert severity="info" sx={{ mb: 4 }}>
        <Typography variant="body2">
          This page explains how users who signed up via Facebook can request deletion of their data from HypeCircle.
        </Typography>
      </Alert>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <Delete color="primary" sx={{ mr: 2 }} />
            <Typography variant="h5" fontWeight="bold">
              Account Deletion Process
            </Typography>
          </Box>
          
          <Typography variant="body1" paragraph>
            If you signed up for HypeCircle using your Facebook account and want to delete your data, you have two options:
          </Typography>

          <Box component="ol" sx={{ pl: 2 }}>
            <Box component="li" sx={{ mb: 2 }}>
              <Typography variant="body1" fontWeight="bold">
                Delete from HypeCircle directly:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • Log into your HypeCircle account<br/>
                • Go to Settings → Account Settings<br/>
                • Click "Delete Account"<br/>
                • Confirm deletion
              </Typography>
            </Box>
            
            <Box component="li" sx={{ mb: 2 }}>
              <Typography variant="body1" fontWeight="bold">
                Request deletion via email:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Send an email to our support team with your deletion request
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <Email color="primary" sx={{ mr: 2 }} />
            <Typography variant="h5" fontWeight="bold">
              Email Deletion Request
            </Typography>
          </Box>
          
          <Typography variant="body1" paragraph>
            Send your deletion request to:
          </Typography>
          
          <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1, mb: 2 }}>
            <Typography variant="h6" color="primary">
              hype.circle.main@gmail.com
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            Please include the following information in your email:
          </Typography>
          
          <Box component="ul" sx={{ pl: 2 }}>
            <Box component="li">Email address associated with your account</Box>
            <Box component="li">Facebook name used to sign up</Box>
            <Box component="li">Subject line: "Data Deletion Request"</Box>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <Security color="primary" sx={{ mr: 2 }} />
            <Typography variant="h5" fontWeight="bold">
              What Data Gets Deleted
            </Typography>
          </Box>
          
          <Typography variant="body1" paragraph>
            When you request account deletion, we will permanently remove:
          </Typography>
          
          <Box component="ul" sx={{ pl: 2 }}>
            <Box component="li">Your profile information (name, email, bio)</Box>
            <Box component="li">All posts, reviews, and comments you've made</Box>
            <Box component="li">Your watchlists and movie ratings</Box>
            <Box component="li">Chat messages and conversations</Box>
            <Box component="li">Any uploaded profile pictures or media</Box>
            <Box component="li">Account preferences and settings</Box>
          </Box>
          
          <Alert severity="warning" sx={{ mt: 2 }}>
            <Typography variant="body2">
              <strong>Note:</strong> Account deletion is permanent and cannot be undone. 
              Please make sure you want to permanently delete your account before proceeding.
            </Typography>
          </Alert>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Processing Time
          </Typography>
          
          <Typography variant="body1" paragraph>
            • In-app deletions are processed immediately
            • Email requests are processed within 30 days
            • You will receive a confirmation email once deletion is complete
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
            For questions about data deletion, contact us at hype.circle.main@gmail.com
          </Typography>
        </CardContent>
      </Card>

      <Box textAlign="center" mt={4}>
        <Button 
          variant="outlined" 
          href="/"
          sx={{ mr: 2 }}
        >
          Back to Home
        </Button>
        <Button 
          variant="contained" 
          href="mailto:hype.circle.main@gmail.com?subject=Data Deletion Request"
        >
          Send Deletion Request
        </Button>
      </Box>
    </Container>
  );
};

export default DataDeletion;